(function () {
  function initEstimateEnquiry(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var tabs = root.querySelectorAll('[data-erk-tab]');
    var panels = root.querySelectorAll('[data-erk-panel]');
    var metalButtons = root.querySelectorAll('[data-erk-metal]');
    var purityButtons = root.querySelectorAll('[data-erk-purity]');
    var submitBtn = root.querySelector('[data-erk-submit]');
    var weightInput = root.querySelector('[data-erk-weight]');
    var itemTypeSelect = root.querySelector('[data-erk-item-type]');
    var brandInput = root.querySelector('[data-erk-brand]');
    var descriptionInput = root.querySelector('[data-erk-description]');

    var activeTab = 'metal';
    var activeMetal = 'Gold';
    var activePurity = { label: '18ct', percent: '75%' };

    function setActiveTab(tab) {
      activeTab = tab;
      tabs.forEach(function (btn) {
        var isActive = btn.dataset.erkTab === tab;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var isActive = panel.dataset.erkPanel === tab;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveTab(btn.dataset.erkTab);
      });
    });

    metalButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeMetal = btn.dataset.erkMetal;
        metalButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        updatePurityVisibility();
      });
    });

    function updatePurityVisibility() {
      var purityGroup = root.querySelector('[data-erk-purity-group]');
      if (purityGroup) {
        purityGroup.hidden = activeMetal === 'Silver';
      }
    }

    purityButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activePurity = {
          label: btn.dataset.erkPurity,
          percent: btn.dataset.erkPercent
        };
        purityButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    function buildMessage() {
      if (activeTab === 'metal') {
        var weight = weightInput ? weightInput.value.trim() : '';
        var lines = [
          'Estimate request — Gold & Silver',
          'Metal: ' + activeMetal
        ];
        if (weight) lines.push('Weight: ' + weight + 'g');
        if (activeMetal === 'Gold') {
          lines.push('Purity: ' + activePurity.label + ' (' + activePurity.percent + ')');
        }
        lines.push('');
        lines.push('Please provide an indicative offer for the above.');
        return lines.join('\n');
      }

      var itemType = itemTypeSelect ? itemTypeSelect.value : '';
      var brand = brandInput ? brandInput.value.trim() : '';
      var description = descriptionInput ? descriptionInput.value.trim() : '';
      var jewelleryLines = [
        'Estimate request — Jewellery & Watches',
        'Item type: ' + (itemType || 'Not specified')
      ];
      if (brand) jewelleryLines.push('Brand: ' + brand);
      if (description) jewelleryLines.push('Description: ' + description);
      jewelleryLines.push('');
      jewelleryLines.push('Please provide a valuation for the above item.');
      return jewelleryLines.join('\n');
    }

    function prefillContactForm(message) {
      var contactSection = document.getElementById('we-buy-contact');
      if (!contactSection) return;

      var bodyField = contactSection.querySelector('textarea[name="contact[body]"]');
      if (bodyField) {
        bodyField.value = message;
        bodyField.dispatchEvent(new Event('input', { bubbles: true }));
      }

      var nameFields = {
        'Estimate Type': activeTab === 'metal' ? 'Gold & Silver' : 'Jewellery & Watches'
      };

      Object.keys(nameFields).forEach(function (fieldName) {
        var input = contactSection.querySelector('[name="contact[' + fieldName + ']"]');
        if (input) input.value = nameFields[fieldName];
      });

      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

      var firstEmpty = contactSection.querySelector('input[type="text"]:not([value]), input[type="email"]');
      if (firstEmpty && !firstEmpty.value) {
        setTimeout(function () { firstEmpty.focus(); }, 400);
      }
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (activeTab === 'metal' && weightInput) {
          var w = parseFloat(weightInput.value);
          if (!weightInput.value.trim() || isNaN(w) || w <= 0) {
            weightInput.focus();
            weightInput.setCustomValidity('Please enter a valid weight in grams.');
            weightInput.reportValidity();
            return;
          }
          weightInput.setCustomValidity('');
        }

        prefillContactForm(buildMessage());
      });
    }

    updatePurityVisibility();
  }

  function initAll() {
    document.querySelectorAll('[data-erk-estimate-enquiry]').forEach(initEstimateEnquiry);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-erk-estimate-enquiry]');
    if (root) initEstimateEnquiry(root);
  });
})();
